import ProducerInterface from "@app/Interface/ProducerInterface";

export default class ProducerModel implements ProducerInterface {
    public id: number;
    public rcdId: string;
    public fieldRepId: string;
    public producerId: number;
    public alphaName: string;
    public name1: string;
    public name2: string;
    public name3: string;
    public name4: string;
    public name5: string;
    public startDate: string;
    public quitDate: string;
    public ssn: string;
    public pdrType: string;
    public fedOrd: string;
    public btu: string;
    public zone: string;
    public hauler: string;
    public haulZone: string;
    public nbrTanks: number;
    public voteDist: string;
    public probCode: string;
    public probStartDate: string;
    public oldPdr: number;
    public phone: string;
    public nonNda: number;
    public taxId: string;
    public taxLegalName: string;
    public state: string;
    public county: string;

    constructor() {
        this.id = 0;
        this.rcdId = '';
        this.fieldRepId = '';
        this.producerId = 0;
        this.alphaName = '';
        this.name1 = '';
        this.name2 = '';
        this.name3 = '';
        this.name4 = '';
        this.name5 = '';
        this.startDate = '';
        this.quitDate = '';
        this.ssn = '';
        this.pdrType = '';
        this.fedOrd = '';
        this.btu = '';
        this.zone = '';
        this.hauler = '';
        this.haulZone = '';
        this.nbrTanks = 0;
        this.voteDist = '';
        this.probCode = '';
        this.probStartDate = '';
        this.oldPdr = 0;
        this.phone = '';
        this.nonNda = 0;
        this.taxId = '';
        this.taxLegalName = '';
        this.state = '';
        this.county = '';
    }

}
